import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { FlatList, View } from "react-native"
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../constants/Colorsv2';
import { Text, TouchableOpacity } from '../globalComponents/NativeOverrides';
import { event_getEventByEventId, event_getLeagues, event_getMatchByMatchId, event_getTournamentByTournamentId } from '../store/actionsv1/events';
import { market_bulkCancelOrder } from '../store/actionsv1/markets';
import { HedgeProps, OrderStatsProps } from '../store/types/mk_svc';
import { EventProps, LeagueProps, MatchProps, TournamentProps } from '../store/types/sr_svc';
import ActionModal from './ActionModal';

type PlayerOrderStatCardProps = {
    player_order_stat: OrderStatsProps,
    prevent_event_load?:boolean,
    hedges: HedgeProps[],
    onPress: (player_order_stat:OrderStatsProps) => void
}

const PlayerOrderStatCard = ({ player_order_stat, hedges, prevent_event_load, onPress }:PlayerOrderStatCardProps) => {
    const [ loaded, setLoaded ] = useState(false);
    const [ show_titles, setShowTitles ] = useState(false);
    const [ loading, setLoading ] = useState(false);
    const [ action_visible, setActionVisible ] = useState(false);
    const dispatch = useDispatch()

    //Check if the order is in the viewport to get event data
    const market_type:string = useSelector((state:any) => state.auth.market_type, (left, right) => left === right)
    const show_unique_orders:boolean = useSelector((state:any) => state.auth.show_unique_orders, (left, right) => left == right);

    const event:EventProps | undefined = useSelector((state:any) => state.event.events[player_order_stat.event_id], (left, right) => left?.time_detail == right?.time_detail)
    let time_detail = event?.time_detail
    if(event && time_detail === 'scheduled'){
        time_detail = moment(event.scheduled_datetime).format('MM/DD @ hh:mm a')
    }
    const tournament:TournamentProps | undefined = useSelector((state:any) => state.event.tournaments[player_order_stat.event_id], (left, right) => left?.tournament_id == right?.tournament_id)
    const match:MatchProps | undefined = useSelector((state:any) => state.event.matches[player_order_stat.event_id], (left, right) => left?.match_id == right?.match_id)
    const leagues:LeagueProps[] = useSelector((state:any) => state.event.leagues, (left, right) => left.length == right.length)
    
    useEffect(() => {
        getDataFromServer()
        if(show_unique_orders){ setShowTitles(true) }
    },[])



    const getDataFromServer = async() => {
        if(loaded){ return }
        if(player_order_stat.event_type === 'team' && !event && !prevent_event_load){ return await dispatch(event_getEventByEventId(player_order_stat.event_id)) }
        if(player_order_stat.event_type === 'tournament' && !tournament){ return await dispatch(event_getTournamentByTournamentId(player_order_stat.event_id)) }
        if(player_order_stat.event_type === 'match' && !match){ return await dispatch(event_getMatchByMatchId(player_order_stat.event_id)) }
        if(leagues.length === 0){ return await dispatch(event_getLeagues())}
        setLoaded(true)
    }

    const getLeague = () => {
        switch(player_order_stat.event_type){
            case 'team': return leagues.find(l => l.league_id == event?.league_id) 
            case 'tournament': return leagues.find(l => l.league_id == tournament?.league_id)
            case 'match': return leagues.find(l => l.league_id == match?.tournament?.league_id)
            default: return undefined 
        }
    }

    const handleCardPress = () => {
        if(!onPress){ return }
        onPress(player_order_stat)
    }

    const handleAction = async(option:{ action:string }) => {
        setActionVisible(false)
        if(loading){ return } //Prevent button mashing
        if(player_order_stat.open_orders.length === 0){ return alert('All orders have been fulfilled') } //If for some reason we dont have the orders in there
        switch(option.action){
            case 'bulk_cancel':
                setLoading(true);
                await dispatch(market_bulkCancelOrder(player_order_stat.open_orders))
                setLoading(false);
                return
            default: return
        }
    }

    const renderOrderTitles = (data : { item:string, index:number }) => {
        return (
            <View style={{ padding:10, borderBottomWidth:1, borderBottomColor:Colors.shades.shade600 }}>
                <Text size={14} color={Colors.brand.midnight} weight='regular'>{data.item}</Text>
            </View>
        )
    }

    const cl = market_type === 'FOR_MONEY' ? '$' : 'E'
    const hedged_amt = hedges.reduce((a,b) => a + b.cash_rcvd, 0)
    

    return (
        <View style={{ padding:10, paddingRight:25, borderRadius: 8, borderWidth:1, borderColor:Colors.shades.shade100  }}>
            <TouchableOpacity style={{ }} onPress={() => handleCardPress()}>
            <View style={{ flexDirection:'row', justifyContent:'space-between', marginBottom:16 }}>
                {getLeague() ?
                <View nativeID='league_lozenge' style={{ borderRadius:100, backgroundColor:Colors.shades.shade100, padding:5, paddingRight:10, paddingLeft:10 }}>
                    <Text size={12} weight='semibold' color={Colors.brand.electric}>{getLeague()?.league_name}</Text>
                </View>
                :<View />}
                <TouchableOpacity style={{ flex:1/5, alignItems:'flex-end' }} onPress={() => setActionVisible(true)}>
                    <Icon name='more-vertical' type='feather' color={Colors.brand.midnight} size={20}/>
                </TouchableOpacity>
            </View>
            <View nativeID='event_title' style={{ flexDirection:'row' }}>
                {player_order_stat.event_type === 'team' && event ?
                    <View style={{ flex:6/7 }}>
                        <Text size={16} weight='bold' color={Colors.brand.midnight}>{event.event_title}</Text>
                        <Text size={12} weight='regular' color={Colors.brand.midnight} style={{marginTop:4}}>{time_detail}: {event.away?.abbr} {event.away_team_score} - {event.home?.abbr} {event.home_team_score}</Text>
                    </View>                    
                :<></>}
                {player_order_stat.event_type === 'tournament' && tournament ?
                    <View style={{ flex:6/7 }}>
                        <Text size={16} weight='bold' color={Colors.brand.midnight}>{tournament.tournament_name}</Text>
                        <Text size={12} weight='regular' color={Colors.brand.midnight} style={{marginTop:4}}>{moment(tournament.scheduled_datetime).format('MM/DD @ hh:mma')}</Text>
                    </View>                    
                :<></>}
                {player_order_stat.event_type === 'match' && match ?
                    <View style={{ flex:6/7 }}>
                        <Text size={16} weight='bold' color={Colors.brand.midnight}>{match.match_title}</Text>
                        <Text size={12} weight='regular' color={Colors.brand.midnight} style={{marginTop:4}}>{moment(match.scheduled_datetime).format('MM/DD @ hh:mma')}</Text>
                    </View>                    
                :<></>}
                <Icon containerStyle={{ flex:1/7, alignItems:'flex-end' }} name='chevron-right' type='feather' size={20} color={Colors.brand.midnight} />
            </View>
            <View style={{ flexDirection:'row', flexWrap:'wrap', marginTop:10 }}>
                {player_order_stat.open_amt > 0 ?
                <View nativeID='open_orders_lozenge' style={{ borderRadius:100, backgroundColor:Colors.shades.shade100, padding:5, paddingRight:10, paddingLeft:10 }}>
                    <Text size={12} weight='semibold' color={Colors.brand.cyan}>OPEN: {cl}{player_order_stat.open_amt.toFixed(2)}</Text>
                </View>
                :<></>}
                {player_order_stat.unresolved_stake + player_order_stat.resolved_stake > 0 ?
                <View nativeID='stake_lozenge' style={{ borderRadius:100, backgroundColor:Colors.shades.shade100, padding:5, paddingRight:10, paddingLeft:10 }}>
                    <Text size={12} weight='semibold' color={Colors.brand.midnight}>POSITION: {cl}{(player_order_stat.unresolved_stake + player_order_stat.resolved_stake).toFixed(2)}</Text>
                </View>
                :<></>}
                {hedges.length > 0 && hedged_amt > 0 ?
                <View nativeID='stake_lozenge' style={{ borderRadius:100, backgroundColor:Colors.highlights.highlight400Faded, padding:5, paddingRight:10, paddingLeft:10 }}>
                    <Text size={12} weight='semibold' color={Colors.brand.midnight}>HEDGED: {cl}{hedged_amt.toFixed(2)}</Text>
                </View>
                :<></>}
                {player_order_stat.position_potential_winnings > 0 ?
                <View nativeID='stake_lozenge' style={{ borderRadius:100, backgroundColor:Colors.shades.shade100, padding:5, paddingRight:10, paddingLeft:10 }}>
                    <Text size={12} weight='semibold' color={Colors.brand.midnight}>TO WIN: {cl}{player_order_stat.position_potential_winnings.toFixed(2)}</Text>
                </View>
                :<></>}
                {player_order_stat.resolved_stake > 0 ?
                <View nativeID='stake_lozenge' style={{ borderRadius:100, backgroundColor:Colors.shades.shade100, padding:5, paddingRight:10, paddingLeft:10 }}>
                    <Text size={12} weight='semibold' color={Colors.brand.midnight}>EARNED: {cl}{player_order_stat.earnings.toFixed(2)}</Text>
                </View>
                :<></>}
            </View>
            
        </TouchableOpacity>
            {player_order_stat.unique_order_titles && player_order_stat.unique_order_titles[0] ?
            <View style={{ marginTop:5, padding:10 }}>
                {show_titles ?
                <FlatList
                    data={player_order_stat.unique_order_titles}
                    renderItem={renderOrderTitles}
                    keyExtractor={(item) => item}
                />
                :<></>}
                <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', marginTop:show_titles?10:0 }} onPress={() => setShowTitles(!show_titles)}>
                    <Icon name={show_titles?'chevron-up':'chevron-down'} type='feather' size={14} color={Colors.brand.electric}/>
                    <Text style={{ marginLeft:5 }} size={14} color={Colors.brand.electric}>{show_titles ? 'Hide Unique Orders' : 'Show Unique Orders'}</Text>
                </TouchableOpacity>
            </View>
            :<></>}
            <ActionModal closeModal={() => setActionVisible(false)} isVisible={action_visible} options={[{ action: 'bulk_cancel', label: 'Cancel Unfulfilled' }]} label_attribute='label' onSelectOption={(option:any) => handleAction(option)}/>
        </View>
       
    )
}

export default PlayerOrderStatCard